/**
 * Power distribution create/update payload helpers (#996).
 */

import type { PowerDistributionConfiguration } from '../types/powerDistribution';

/** Strip server metadata before POST /requests/:id/power-distribution */
export function toCreatePowerDistributionPayload(
  unit: PowerDistributionConfiguration,
): Omit<PowerDistributionConfiguration, 'id' | 'createdAt' | 'updatedAt'> {
  const {
    id: _id,
    createdAt: _createdAt,
    updatedAt: _updatedAt,
    ...payload
  } = unit;
  return payload;
}
